module.exports = __webpack_public_path__ + "assets/images/fleet-parade.29bf3128d8f4bbe94fd66712b3a42527.svg";